export default __webpack_public_path__ + "static/media/icons-project-budget.59ce2e8c.svg";